import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React from 'react'
import Footer from './Common_Components/Footer'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useState, useEffect, useContext } from 'react';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import { ProductContext } from "../context/AppContext";
const LifeOldJapanDay0 = () => {
  const [activePage, setActivePage] = useState("Learning");
  const navigate = useNavigate();
  const location = useLocation();
  // const {categoryId, dayId, dayName, skitname, dayLen} = route.params;
  const StartNow = location.state;
  const categoryId = StartNow?.categoryId;
  const dayId = StartNow?.dayId;
  const dayName = StartNow?.dayName;
  const skitname = StartNow?.skitname;
  const dayLen = StartNow?.dayLen;
  const imageURL = StartNow?.imageURL;
  console.log("skit Screen Data :", categoryId, dayId, dayName, skitname, dayLen);
  console.log("imageURL: ", imageURL);
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
  const { Translate } = useContext(ProductContext);

  return (
    <div className='Life_Old_Japan_container d-flex flex-column' style={{ minHeight: "100vh" }} >
      <div className='header_inner'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <ArrowBackIosIcon onClick={() => navigate(-1)} className='icon_1' />
              <h2>{dayName}</h2>
              <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
            </div>


          </div>
        </div>
      </div>
      <div className="tiles-wrapper-LOJday0">
        <div className="col-12 baby-pink-box">
          <img
            className="starter-image"
            src={`${process.env.PUBLIC_URL}/assets/images/starter.png`}
            alt="Penguin"
          />

          <button
            onClick={() => {
              navigate('/LifeOldJapanVoice', {
                state: {
                  categoryId: categoryId,
                  dayId: dayId,
                  dayName: dayName,
                  skitname: skitname,
                  dayLen: dayLen,
                  imageURL: imageURL,
                },
              });
            }}
            className="start-now-btn mb-2"
          >
            {Translate?.message?.data?.startNow || "Start Now"}
          </button>

        </div>
      </div>
      <Footer />

    </div>
  )
}

export default LifeOldJapanDay0
